"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCurrentOpeningHours = void 0;
const libs_utils_1 = require("@hotelplan/libs.utils");
const schedule_constants_1 = require("./schedule.constants");
function formatTime(time) {
    const [hours, minutes] = time.split(`:`);
    return `${hours}:${minutes}`;
}
function getCurrentOpeningHours(openingHours, currentDate = new Date(), { language, timeZone, cutSeconds = true } = {}) {
    var _a, _b, _c;
    const isoDay = timeZone
        ? parseInt((0, libs_utils_1.formatDateInTimeZone)(currentDate, `i`, language, timeZone))
        : (0, libs_utils_1.getISODay)(currentDate);
    const dayKey = (_a = schedule_constants_1.isoDayMappings.find(([day]) => day === isoDay)) === null || _a === void 0 ? void 0 : _a[1];
    if (!dayKey) {
        throw new Error(`Invalid ISO day`);
    }
    const dayOpeningHours = openingHours[dayKey];
    const shifts = !cutSeconds
        ? (dayOpeningHours === null || dayOpeningHours === void 0 ? void 0 : dayOpeningHours.shifts) || []
        : ((_b = dayOpeningHours === null || dayOpeningHours === void 0 ? void 0 : dayOpeningHours.shifts) === null || _b === void 0 ? void 0 : _b.reduce(function (acc, shift) {
            acc.push({
                from: formatTime(shift.from),
                to: formatTime(shift.to),
            });
            return acc;
        }, [])) || [];
    return {
        shifts,
        day: dayKey,
        open: Boolean(dayOpeningHours && ((_c = dayOpeningHours === null || dayOpeningHours === void 0 ? void 0 : dayOpeningHours.shifts) === null || _c === void 0 ? void 0 : _c.length)),
    };
}
exports.getCurrentOpeningHours = getCurrentOpeningHours;
//# sourceMappingURL=getCurrentOpeningHours.js.map